import React from 'react';
import { useSelector } from 'react-redux';
import { ErrorBoundary, PostMetaHeaderTags } from 'mm-ui-components';
import { PageImage } from 'mm-ui-components/dist/src/base/metaHeaderTags/metaTags.utils';
import {
  getAmpURL,
  getCanonicalUrl,
  getFacebookAppId,
  getFacebookPageId,
  getFavicon,
  getLogoUrl,
  getPrevCanonicalUrl,
  getSiteName,
  getTwitterAccount,
} from '../../store/config/config.selectors';

interface PostMetaTagsProps {
  pageDescription: string;
  seoTitle: string;
  pageImage: PageImage;
  authors: { name: string }[] | null;
  createdAt: string;
  updatedAt: string;
  noIndex: boolean;
  ogDescription: string;
  ogTitle: string;
  ogImage: PageImage;
  twitterDescription: string;
  twitterTitle: string;
  twitterImage: PageImage;
  seoDescription: string;
  articleSection: string;
}

export const PostMetaTagsConnected: React.FunctionComponent<PostMetaTagsProps> = props => {
  const facebookAppId = useSelector(getFacebookAppId);
  const facebookPageId = useSelector(getFacebookPageId);
  const siteName = useSelector(getSiteName);
  const canonicalUrl = useSelector(getCanonicalUrl);
  const favicon = useSelector(getFavicon);
  const twitterAccount = useSelector(getTwitterAccount);
  const logoUrl = useSelector(getLogoUrl);
  const ampURL = useSelector(getAmpURL);
  const prevCanonicalUrl = useSelector(getPrevCanonicalUrl);
  const { pageDescription, seoTitle, pageImage, authors, createdAt, updatedAt, noIndex, ogDescription, ogTitle, ogImage, twitterDescription,
  twitterTitle, twitterImage, seoDescription, articleSection } = props;
  return (
    <PostMetaHeaderTags {...{
      facebookAppId,
      facebookPageId,
      pageDescription,
      siteName,
      canonicalUrl,
      favicon,
      seoTitle,
      twitterAccount,
      pageImage,
      logoUrl,
      authors,
      createdAt,
      updatedAt,
      ampURL,
      prevCanonicalUrl,
      noIndex,
      ogDescription,
      ogTitle,
      ogImage,
      twitterDescription,
      twitterTitle,
      twitterImage,
      seoDescription,
      articleSection,
    }}
    />
  );
};
export const PostMetaTags: React.FunctionComponent<PostMetaTagsProps> = props => <ErrorBoundary><PostMetaTagsConnected {...props} /></ErrorBoundary>;
